module.exports = __webpack_public_path__ + "img/googleplay.305a4893.png";